import { render } from "./DeptCard.vue?vue&type=template&id=c463da2e&scoped=true&ts=true"
import script from "./deptCardHelper.ts?vue&type=script&lang=ts"
export * from "./deptCardHelper.ts?vue&type=script&lang=ts"

import "./DeptCard.vue?vue&type=style&index=0&id=c463da2e&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c463da2e"]])

export default __exports__